"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * {@docCategory Rating}
 */
var RatingSize;
(function (RatingSize) {
    RatingSize[RatingSize["Small"] = 0] = "Small";
    RatingSize[RatingSize["Large"] = 1] = "Large";
})(RatingSize = exports.RatingSize || (exports.RatingSize = {}));
//# sourceMappingURL=Rating.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Rating/Rating.types.js
// module id = 1134
// module chunks = 0